import { XStack, Text } from "tamagui";
import { colors } from "@styles/colors";

interface PrimaryBtnProps {
  active?: boolean;
  onPress?: () => void;
  children: React.ReactNode;
}

/** 主要按鈕：啟用時藍色漸層（primary-bg-gradient），停用時灰底。對齊既有 register 按鈕樣式。 */
export const PrimaryBtn = ({ active = true, onPress, children }: PrimaryBtnProps) => (
  <XStack
    className={active ? "primary-bg-gradient" : undefined}
    backgroundColor={active ? undefined : colors.bgGray1}
    borderRadius={16}
    p={15}
    ai="center"
    jc="center"
    cursor={active ? "pointer" : "default"}
    opacity={active ? 1 : 0.9}
    onPress={active ? onPress : undefined}>
    <Text color={active ? colors.light : colors.gray200} fontSize={16} fontWeight="800">
      {children}
    </Text>
  </XStack>
);

interface SecondaryBtnProps {
  onPress?: () => void;
  children: React.ReactNode;
  danger?: boolean;
}

/** 次要按鈕：白底外框。 */
export const SecondaryBtn = ({ onPress, children, danger }: SecondaryBtnProps) => (
  <XStack
    backgroundColor={colors.light}
    borderRadius={16}
    borderWidth={1.5}
    borderColor={danger ? colors.dangerLight : colors.border}
    p={14}
    ai="center"
    jc="center"
    cursor="pointer"
    onPress={onPress}>
    <Text color={danger ? colors.danger : colors.sub} fontSize={15} fontWeight="700">
      {children}
    </Text>
  </XStack>
);
